import React, { useState, useContext, useEffect } from "react";
import { UncontrolledCollapse, Button, CardBody, Card } from "reactstrap";
import axios from "axios";
import { navigate, graphql } from "gatsby";
import { AppContext } from "../contexts";
import Layout from "../components/layout";
import Loader from "../components/loader";
import ErrorDialog from "../components/errorDialog";
import Slider from "../components/slider";
import CampaignInfo from "../components/campaignInfo";
import { windscreenWorkShops } from "../config/windscreen-panel";
import { othersWorkshops } from "../config/other-panel";
import { drsPanelWorkshops } from "../config/drs-panel";
import { groupBy } from "lodash";
import { startCase } from "lodash";
import { toLower } from "lodash";
import langBM from "../languages/bm"
import langEN from "../languages/en"

export default ({ data }) => {
  const [isOpen, setIsOpen] = useState(false);
  const toggle = () => setIsOpen(!isOpen);

  const [lang, setLang] = useState(langEN)

  useEffect(() => {    
    let cookieLang 
    try {
      cookieLang = document.cookie.split("; ").find(row => row.startsWith("lang=")).split("=")[1]
      if (cookieLang === "BM") {
    	   setLang(langBM)
	    }else{
        setLang(langEN)
      }
    } catch (err) {
      setLang(langEN)
    }
    
  }, [])

  const state = useContext(AppContext);
  const tabStyle = {
    cursor: "pointer",
  };
  const selectedTabStyle = Object.assign({}, tabStyle);
  selectedTabStyle.backgroundColor = "#CC0022";
  selectedTabStyle.color = "white";

  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [errorMessage, setErrorMessage] = useState(false);
  const [area, setArea] = useState("All");
  const [areas, setAreas] = useState([]);
  const [shopState, setShopState] = useState("");
  const [workshops, setWorkshops] = useState([]);
  const [workshopType, setWorkShopType] = useState("windscreen");

  const updateWorkShops = (workshopType, shopState, area) => {
    let shopLists = [];
    let areaOptions = [];
    if (workshopType === "windscreen") shopLists = windscreenWorkShops;
    else if (workshopType === "drs-quality") shopLists = drsPanelWorkshops;
    else if (workshopType === "other") shopLists = othersWorkshops;
    if (shopState !== "All") {
      shopLists = shopLists.filter((shop) => shop.State === shopState);
      areaOptions = Object.keys(groupBy(shopLists, "Area"));
    }
    if (area !== "All") {
      shopLists = shopLists.filter((shop) => shop.Area === area);
    }
    setAreas(areaOptions);
    setWorkshops(shopLists.filter(shop => shop.Status === 1));
  };

  const handleWorkShopChange = (e) => {
    const { value } = e.target;
    console.log("Event: ", e);
    console.log("Event: ", value);
    setWorkShopType(value);
    setShopState("All");
    setArea("All");
    updateWorkShops(value, "All", "All");
  };
  const handleShopStateChange = (e) => {
    const { value } = e.target;
    console.log("Event: ", e);
    console.log("Value: ", value);
    setShopState(value);
    setArea("All");
    updateWorkShops(workshopType, value, "All");
  };
  const handleAreaChange = (e) => {
    const { value } = e.target;
    console.log("Event: ", e);
    console.log("Value: ", value);
    setArea(value);
    updateWorkShops(workshopType, shopState, value);
  };

  useEffect(() => {
    console.log(areas);
  }, [areas]);
  return (
    <Layout pageTitle="Authorised Panel Workshops" lang={lang}>
      <div className="product-bg">
        <div className="container">
          <div className="">
            <div
              className="container mt-1 mobile-mt_none"
              styles={{ "padding-bottom": "60px" }}
            >
              <div className="content-area box-shadow">
                <div class="row">
                  <div class="text-center col-md-8 mb-5 offset-md-2">
                      <h3 class="title">Authorised Panel Workshops</h3>
                      <h2 class="mt-2 sub-title">Search the following workshops listing to find out more.</h2>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-4">
                    <div className="form-group">
                      <label for="txtType">Type of Workshop</label>
                      <span className="sompo-form">
                        <select
                          className="form-control"
                          id="txtType"
                          onChange={(e) => {
                            handleWorkShopChange(e);
                          }}
                        >
                          <option value="">Select</option>
                          <option value="drs-quality">
                            DRS Quality Workshops
                          </option>
                          <option value="other">Other Panel Workshops</option>
                          <option value="windscreen">
                            Windscreen Repairs and Replacement Centres
                          </option>
                        </select>
                      </span>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-group">
                      <label for="txtState">State</label>
                      <span className="sompo-form">
                        <select
                          className="form-control"
                          id="txtState"
                          onChange={(e) => handleShopStateChange(e)}
                          value={shopState}
                        >
                          <option value="">Select</option>
                          <option value="Johor">Johor</option>
                          <option value="Kedah">Kedah</option>
                          <option value="Kelantan">Kelantan</option>
                          <option value="Kuala Lumpur">Kuala Lumpur</option>
                          <option value="Malacca">Malacca</option>
                          <option value="Negeri Sembilan">
                            Negeri Sembilan
                          </option>
                          <option value="Pahang">Pahang</option>
                          <option value="Penang">Penang</option>
                          <option value="Perak">Perak</option>
                          <option value="Perlis">Perlis</option>
                          <option value="Sabah">Sabah</option>
                          <option value="Sarawak">Sarawak</option>
                          <option value="Selangor">Selangor</option>
                          <option value="Terengganu">Terengganu</option>
                        </select>
                        <input
                          type="hidden"
                          name="ctstae"
                          id="ctstae"
                          value="8"
                        />
                      </span>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-group">
                      <label for="txtArea">Area</label>
                      <span className="sompo-form">
                        <select
                          className="form-control"
                          id="txtArea"
                          onChange={(e) => handleAreaChange(e)}
                        ><option value="All">All</option>
                          {areas.length &&
                            areas.map((area) => (
                              <option value={area}>
                                {startCase(toLower(area))}
                              </option>
                            ))}
                        </select>
                      </span>
                    </div>
                  </div>
                </div>
                <br />

                <h4>Search Result(s)</h4>
                <div>
                  {workshops.length ? (
                    workshops.map((workshop) => {
                      return (
                        <div className="row workshop">
                          <div className="col-md-6">
                            <div className="address">
                              <b>{workshop.Name}</b>
                              <br />
                              <p>
                                {workshop.Address &&
                                  workshop.Address.split("\n").map(
                                    (address, idx) => (
                                      <>
                                        {address}
                                        {workshop.Address.length - 1 !== idx &&
                                          address !== "" && <br />}
                                      </>
                                    )
                                  )}
                              </p>
                              {/* <p>{workshop.Address}</p> */}
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="tel">
                              {workshop.Tel &&
                                workshop.Tel.length &&
                                workshop.Tel.split("\n").map((telNo, idx) => (
                                  <>
                                    <a href={`tel:${telNo}`}>{telNo}</a>
                                    {workshop.Tel.length - 1 !== idx &&
                                      telNo !== "" && <br />}
                                  </>
                                ))}
                            </div>
                            {workshop.Fax && (
                              <div className="fax">
                                <a href={`tel:${workshop.Fax}`}>
                                  {workshop.Fax}
                                </a>
                                <br />
                              </div>
                            )}
                            <div className="email">
                              {workshop.Email &&
                                workshop.Email.length &&
                                workshop.Email.split("\n").map((email, idx) => (
                                  <>
                                    <a href={`mailto:${email}`}>{email}</a>
                                    {workshop.Email.length - 1 !== idx &&
                                      email !== "" && <br />}
                                  </>
                                ))}
                            </div>
                          </div>
                        </div>
                      );
                    })
                  ) : (
                    <div>No Result</div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {isLoading ? <Loader /> : null}
      <ErrorDialog
        isOpen={isError}
        toggle={() => setIsError((v) => !v)}
        message={errorMessage}
        lang={lang}
      />
    </Layout>
  );
};

// export const query = graphql`
//   query {
//     mobileHeader: file(
//       relativePath: { eq: "secmotor-mslider-2309-untow.jpg" }
//     ) {
//       childImageSharp {
//         fluid(maxWidth: 585) {
//           ...GatsbyImageSharpFluid_withWebp_tracedSVG
//         }
//       }
//     }
//     desktopHeader: file(
//       relativePath: { eq: "secmotor-slider-2309-untow.jpg" }
//     ) {
//       childImageSharp {
//         fluid(maxWidth: 1440) {
//           ...GatsbyImageSharpFluid_withWebp_tracedSVG
//         }
//       }
//     }
//     mobileTng: file(relativePath: { eq: "img-slider-tng-425.jpg" }) {
//       childImageSharp {
//         fluid(maxWidth: 585) {
//           ...GatsbyImageSharpFluid_withWebp_tracedSVG
//         }
//       }
//     }
//     desktopTng: file(relativePath: { eq: "img-slider-tng-1440.jpg" }) {
//       childImageSharp {
//         fluid(maxWidth: 1440) {
//           ...GatsbyImageSharpFluid_withWebp_tracedSVG
//         }
//       }
//     }
//   }
// `;
